export default {
    getStaff(state, data) {
        state.staff=data;
    },
};
